import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './SizeModalTabs.css';
import classNames from 'classnames';

const Ski = ({ intl }) => {
  return (
    <div className={css.sections}>
      <div className={css.wrapper}>
        <p className={css.content} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'SizesModal.SkiTab.1sectionContent' }) }} />
        <div className={css.tableWrapper}>
          <table className={css.table}>
            <thead>
              <tr>
                <th><FormattedMessage id="SizesModal.SkiTab.height" /></th>
                <th><FormattedMessage id="SizesModal.SkiTab.level" /></th>
                <th><FormattedMessage id="SizesModal.SkiTab.sizeMan" /></th>
                <th><FormattedMessage id="SizesModal.SkiTab.sizeWoman" /></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>150</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>135 - 140</div><div>140 - 145</div><div>145 - 150</div></td>
                <td><div>130 - 135</div><div>135 - 140</div><div>140 - 145</div></td>
              </tr>

              <tr>
                <td>155</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>140 - 145</div><div>145 - 150</div><div>150 - 155</div></td>
                <td><div>135 - 140</div><div>140 - 145</div><div>145 - 150</div></td>
              </tr>

              <tr>
                <td>160</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>145 - 150</div><div>150 - 155</div><div>155 - 160</div></td>
                <td><div>140 - 145</div><div>145 - 150</div><div>150 - 155</div></td>
              </tr>

              <tr>
                <td>165</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>150 - 155</div><div>155 - 160</div><div>160 - 165</div></td>
                <td><div>145 - 150</div><div>150 - 155</div><div>155 - 160</div></td>
              </tr>

              <tr>
                <td>170</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>155 - 160</div><div>160 - 165</div><div>165 - 170</div></td>
                <td><div>150 - 155</div><div>155 - 160</div><div>160 - 165</div></td>
              </tr>

              <tr>
                <td>175</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>160 - 165</div><div>165 - 170</div><div>170 - 175</div></td>
                <td><div>155 - 160</div><div>160 - 165</div><div>165 - 170</div></td>
              </tr>

              <tr>
                <td>180</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>165 - 170</div><div>170 - 175</div><div>175 - 180</div></td>
                <td><div>160 - 165</div><div>165 - 170</div><div>170 - 175</div></td>
              </tr>

              <tr>
                <td>185</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>170 - 175</div><div>175 - 180</div><div>180 - 185</div></td>
                <td><div>165 - 170</div><div>170 - 175</div><div>175 - 180</div></td>
              </tr>
              <tr>
                <td>190</td>
                <td>
                  <div><FormattedMessage id="SizesModal.SkiTab.basic" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.medium" /></div>
                  <div><FormattedMessage id="SizesModal.SkiTab.advanced" /></div>
                </td>
                <td><div>175 - 180</div><div>180 - 185</div><div>185 - 190</div></td>
                <td><div>170 - 175</div><div>175 - 180</div><div>180 - 185</div></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <p className={classNames(css.content,css.pointers)} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'SizesModal.SkiTab.2sectionContent' }) }} />
      </div>
    </div>
  )
}

export default Ski;